import styles from "./Sidebar.module.scss";
import classNames from "classnames/bind";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHouse,
    faRankingStar,
    faNewspaper,
    faDiamond,
} from "@fortawesome/free-solid-svg-icons";
import { Routers } from "~/routes";
const cx = classNames.bind(styles);
function Sidebar() {
    console.log("Sidebar");
    return (
        <div className={cx("wrapper")}>
            <div className={cx("inner")}>
                <NavLink
                    to={Routers.home}
                    className={(nav) =>
                        cx("link_item", { active: nav.isActive })
                    }
                >
                    <FontAwesomeIcon className={cx("icon")} icon={faHouse} />
                    <span> Home</span>
                </NavLink>
                <NavLink
                    to={Routers.cars}
                    className={(nav) =>
                        cx("link_item", { active: nav.isActive })
                    }
                >
                    <FontAwesomeIcon className={cx("icon")} icon={faDiamond} />
                    <span>Hãng xe</span>
                </NavLink>
                <NavLink
                    className={(nav) =>
                        cx("link_item", { active: nav.isActive })
                    }
                    to={Routers.rank}
                >
                    <FontAwesomeIcon
                        className={cx("icon")}
                        icon={faRankingStar}
                    />
                    <span>Xếp hạng</span>
                </NavLink>
                <NavLink
                    className={(nav) =>
                        cx("link_item", { active: nav.isActive })
                    }
                    to={Routers.blog}
                >
                    <FontAwesomeIcon
                        className={cx("icon")}
                        icon={faNewspaper}
                    />
                    <span>Tin tức</span>
                </NavLink>
            </div>
        </div>
    );
}

export default Sidebar;
